import { createRouteRef } from '@backstage/frontend-plugin-api';

/*
 * The portal's first parameterised route. Both refs bind to sibling
 * `PageBlueprint`s in `index.tsx`.
 *
 * - Not `SubPageBlueprint` — it renders what it attaches as a header tab.
 * - Not `SubRouteRef` — `PageBlueprint.routeRef` only takes a `RouteRef`.
 * - Link with `useRouteRef`, read the param with `useRouteRefParams`, never
 *   compose the path by hand. `useRouteRef` returns `undefined` when the route
 *   is not mounted, so callers handle an absent path.
 */
export const incidentsRouteRef = createRouteRef();

export const incidentDetailRouteRef = createRouteRef({
  params: ['incidentId'],
});
